import { LoadService } from './_shared/services';
import { icons } from './_shared/icons/icons';
import { registerLocaleData } from '@angular/common';
import localePl from '@angular/common/locales/pl';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { DEFALUT_METADATA } from './_shared/texts';
import { environment } from '../environments/environment';
registerLocaleData(localePl, 'pl');
export function init_app(load) {
    return () => load.initializeApp();
}
const ɵ0 = () => 'sc', ɵ1 = () => environment, ɵ2 = () => DEFALUT_METADATA, ɵ3 = () => process.env.SC_TURNSTILE_SITE_KEY;
export class AppModule {
    constructor(library) {
        library.addIcons(...icons);
    }
}
export { ɵ0, ɵ1, ɵ2, ɵ3 };
